import ContactMessagesTable from "../components/contact-messages-table";

function SupportPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Support</h1>
          <p className="text-muted-foreground mt-1">
           View and respond to customer inquiries
          </p>
        </div>

        {/* <Link to="/app/add-order">
          <Button
            variant="default"
            className="flex items-center gap-2"
          >
            <Plus className="h-5 w-5" />
            Add Order
          </Button>
        </Link> */}
      </div>

      <div className="rounded-lg border bg-card">
        <ContactMessagesTable />
      </div>
    </div>
  );
}

export default SupportPage;
